import React, { useContext, useEffect } from "react";
import Card from "../../components/Card/Card";
import Row, { Col } from "../../Layout/Responsive";
import "./members.scss";
import "../Team/team.scss";
import GlobalContext from "../../context/GlobalContext";
import { adminBg, mug404 } from "../../utils/images";

const Members = () => {
	const { people, team, getAllPeople, restructureTeam } =
		useContext(GlobalContext);
	const createTeam = async () => {
		const allPeople = await getAllPeople();
		restructureTeam(allPeople);
	};
	useEffect(() => {
		createTeam();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<main
			className="team members applications"
			style={{
				backgroundImage: `url(${adminBg})`,
			}}
		>
			{people.some((m) => !m.verified) && (
				<section className="members-group team-group">
					<h1>Member requests to be verified</h1>
					<div className="members-group__members">
						<Row>
							{team.map((group, id) => {
								return group.members.map((person, index) => {
									return (
										!person.verified && (
											<Col
												lg={33}
												md={50}
												sm={100}
												key={index}
											>
												<Card {...person} />
											</Col>
										)
									);
								});
							})}
						</Row>
					</div>
				</section>
			)}
			{people.some((m) => m.verified) && (
				<section className="members-group team-group">
					<h1>Verified Members</h1>
					<div className="members-group__members">
						<Row>
							{team.map((group, id) => {
								return group.members.map((person, index) => {
									return (
										person.verified && (
											<Col
												lg={33}
												md={50}
												sm={100}
												key={index}
											>
												<Card {...person} />
											</Col>
										)
									);
								});
							})}
						</Row>
					</div>
				</section>
			)}
			{people.length === 0 && (
				<div className="null">
					<div className="null-image">
						<img src={mug404} alt="Broken Mug" />
					</div>
					<div className="null-text">
						<h2>Nothing to see here</h2>
					</div>
				</div>
			)}
		</main>
	);
};

export default Members;
